import { showSuccess, showError } from '../scripts/notyf'; // Импортируем функции из notification.js
import * as FilePond from 'filepond';
import 'filepond/dist/filepond.min.css';
import pt_RU from 'filepond/locale/ru-ru.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

FilePond.setOptions(pt_RU);
FilePond.registerPlugin(FilePondPluginImagePreview);

// Инициализация FilePond
document.querySelectorAll('input.filepond').forEach(input => {
    const pond = FilePond.create(input, {
        allowMultiple: true,
        credits: false
    });

    // Обработчик нажатия на кнопку отправки
    document.querySelectorAll('form button[type="submit"]').forEach(button => {
        button.addEventListener('click', function (event) {
            const form = this.closest('form');
            const formdata = new FormData(form);

            if (!validateRating(formdata)) {
                event.preventDefault();
                showError('Заполните поле рейтинг');
            }
        });
    });

    // Функция для проверки рейтинга
    function validateRating(formdata) {
        if (formdata.has('review[rating]')) {
            const rating = formdata.get('review[rating]');
            return rating !== '';  // Возвращаем true, если поле не пустое
        } else {
            return true;
        }
    }

    // Обработчик отправки формы
    document
        .getElementById('review-form')
        .addEventListener('submit', reviewSubmitHandler);


    function reviewSubmitHandler(event) {
        event.preventDefault();

        const form = event.currentTarget;          // та самая форма
        const formdata = new FormData(form);

        // добавляем файлы из FilePond
        if (pond && pond.getFiles().length) {
            pond.getFiles().forEach(file => {
                formdata.append('review[mediaReviews][]', file.file);
            });
        }

        fetch('/submit-review', {
            method: 'POST',
            body: formdata
        })
            .then(r => r.json())
            .then(resp => {
                if (resp.status === 'success') {
                    showSuccess(resp.message);
                } else {
                    showError('Ошибка: ' + resp.message);
                    handleFormErrors(resp.errors);
                }
            })
            .catch(() => alert('Произошла ошибка при отправке формы. Попробуйте позже.'));
    }

    // Функция для обработки ошибок формы
    function handleFormErrors(errors) {
        Object.keys(errors).forEach(field => {
            const errorMessages = errors[field];
            errorMessages.forEach(function (error) {
                showError(`Ошибка в поле ${field}: ${error}`);
            });
        });
    }
});
